import { ApprovementDetailComponent } from './approvement-detail.component';

export default ApprovementDetailComponent;
